import { PropsWithChildren } from 'react';

import styles from './note.module.scss';

const Note = (props: PropsWithChildren<any>) => {
    return <div className={styles.note}>{props.children}</div>;
};

export default Note;
